import { httpService } from '../..';
import { ApiUrls } from '../ApiUrls';
import { IOpenOrdersRequest, IOpenOrdersResponse, IOrder } from './orderInterfaces';

export async function fetchOpenOrders(
  request: IOpenOrdersRequest,
  salesDistricts: string[],
  companies: string[]
): Promise<IOpenOrdersResponse> {
  try {
    const response = await httpService.get(ApiUrls.getOpenOrders(salesDistricts, companies, request.skip));
    return await response.json();
  } catch (e) {
    throw e;
  }
}

export async function fetchOrder(salesId: string): Promise<IOrder> {
  try {
    const response = await httpService.get(ApiUrls.getOrder(salesId));
    var order = await response.json();
    if (order.constructor === Array) {
      return order[0];
    }
    else {
      return order;
    }
  } catch (e) {
    throw e;
  }
}
